import MintedImg from "../../../../assets/images/minted.png";
import deliveryImg from "../../../../assets/images/delivery.png";
import purityImg from "../../../../assets/images/purity.png";

const Icons = () => (
  <div className="logos-container">
    <div className="logo-item">
      <img src={purityImg} alt="Purity" />
      <span>Trusted Purity</span>
    </div>
    <div className="divider"></div>
    <div className="logo-item">
      <img src={deliveryImg} alt="Delivery" />
      <span>Fast Delivery</span>
    </div>
    <div className="divider"></div>
    <div className="logo-item">
      <img src={MintedImg} alt="Minted Bullion" />
      <span>Minted Bullion</span>
    </div>
  </div>
);

export default Icons;
